import { makeStyles, createStyles, Theme, Hidden } from "@material-ui/core";
import ceaLogo from "./CEA.svg";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cceaLogo: {
      width: 90,
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
    },
  })
);

export const CCEALogo = () => {
  const classes = useStyles();
  return (
    <Hidden xsDown implementation="css">
      <a href="http://ccea.org.uk/" target="_blank" rel="noopener noreferrer">
        <img src={ceaLogo} alt="CCEA logo" className={classes.cceaLogo} />
      </a>
    </Hidden>
  );
};
